import React, { useCallback, ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { StoreInfoSecurelyNote } from '../../../../general/components/store-info-securely-note';
import { WizardPage } from '../../../../general/components/wizard-page';
import { GET_STARTED } from '../../../../paths';
import { RootState } from '../../../../store';
import { VerifyPhoneForm } from '../../components/verify-phone-form';

const selector = ({
  session: { error, loading },
  preliminaryInfo: {
    info: { phone },
  },
  nextStep: { loading: nextStepLoading },
  consent: { loading: consentLoading, error: consentError },
}: RootState) => {
  return {
    error,
    loading,
    phone,
    nextStepLoading,
    consentLoading,
    consentError,
  };
};

const VerifyPhonePageV2 = (): ReactElement => {
  const navigate = useNavigate();
  const { error, loading, phone, nextStepLoading, consentLoading, consentError } = useSelector(selector);

  const handleBack = useCallback(() => {
    navigate(GET_STARTED);
  }, [navigate]);

  return (
    <WizardPage title="Verify your phone number" onBack={handleBack} error={error ?? consentError}>
      <VerifyPhoneForm
        loading={loading}
        nextStepLoading={nextStepLoading}
        consentLoading={consentLoading}
        phone={phone}
        portalType={'verify'}
      />
      <StoreInfoSecurelyNote sx={{ mt: 4 }} />
    </WizardPage>
  );
};

export { VerifyPhonePageV2 };
